module.exports = __webpack_public_path__ + "img/LPW_Dagger.a9fc0da2.png";